<div class=" mx-auto h-28 py-2 rounded-xl bg-white-100 flex justify-between flex-col shadow-[0_-0.5px_1.5px_rgba(0,0,0,0.025),_0_4px_6px_rgba(0,0,0,0.1)] text-gray-600" [ngClass]="{'animate-pulse':isLoading}">
    <div class="flex gap-2 justify-between">
        <div class="ml-2 rounded-full w-10 h-10 flex items-center justify-center"
        [ngClass]="{
            'bg-blue-50 text-cliking_blue': source=='linkedin',
            'bg-red-50 text-[#ea580c]': source=='google',
            'bg-indigo-50 text-[#1877f2]': source=='facebook',
            'bg-pink-100 text-[#b82463]': source=='instagram'
            }">
            <app-svg-palette [icon]="data?.icon"/>
            <!-- <span class="text-xs">{{icon}}</span> -->
        </div>

        <span class="text-2xl mx-auto font-bold cursor-default" [title]="data?.value" >{{data?.value|kMNotation}} {{data?.unit}}</span>
    </div>

    <div class="text-sm ml-2 font-semibold leading-5 flex gap-2">
        {{data?.label | translate}}
        <div class="tooltip text-start font-normal italic"
        [ngClass]="data?.tooltipPosition"
        [attr.data-tip]="data?.tooltip | translate"
         style="
         --tooltip-color: white;
         --tooltip-text-color: #555;
         --tooltip-padding: 1rem;
         --tooltip-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
         "
         >
            <svg class="mt-1"  width="12px"  viewBox="0 0 24 24" fill="none"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM10.25 11C10.25 10.4477 10.6977 10 11.25 10H12.75C13.3023 10 13.75 10.4477 13.75 11V18C13.75 18.5523 13.3023 19 12.75 19H11.25C10.6977 19 10.25 18.5523 10.25 18V11ZM14 7C14 5.89543 13.1046 5 12 5C10.8954 5 10 5.89543 10 7C10 8.10457 10.8954 9 12 9C13.1046 9 14 8.10457 14 7Z" fill="currentColor"></path> </g></svg>
        </div>
    </div>

</div>
